import { Box, Button, IconButton, Paper, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { usePrevious } from "../../components/CustomHooks";
import useApi from "../../api";
import TableLoader from "../../components/TableLoader";
import EmptyStateLabel from "../../components/EmptyStateLabel";
import { DataGrid } from "@mui/x-data-grid";
import { Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { GRID_DEFAULT_PAGINATION_MODEL } from "../../components/DataGrid";
import normalizeFiltros from "../../components/app/Filtros";
import { consultarEstanciasAbiertas } from "../../api/controlador";
import { formatDateInYear, formatTag, renderTiempoEstancia } from "../../components/Formatter";
import RegistrarIncidenciaDialog from "../acciones/RegistrarIncidenciaDialog";
import Panel from "../../components/Panel";
import CerrarEstanciaPensionado from "../acciones/CerrarEstanciaPensionado";

const defaultFiltros = {
    //estacionamientoId: '',
    query: '',
}

export default function ListadoEstanciasAbiertas({ ...props }) {
    const { reload } = props;
    const navigate = useNavigate();

    const [filtros, setFiltros] = useState(defaultFiltros);

    const [paginationModel, setPaginationModel] = useState(GRID_DEFAULT_PAGINATION_MODEL);
    const prevDataPM = usePrevious(paginationModel);
    //const prevQuery = usePrevious(filtros.query);

    const [rowCount, setRowCount] = useState(0);
    const [selected, setSelected] = useState([]);
    const [registros, setRegistros] = useState(null);

    const [{ data: registrosData, loading: loadingEstancias }, registrosApi] = useApi();

    useEffect(() => {
        realizarConsultaRegistros();
    }, []);

    useEffect(() => {
        if (reload) {
            realizarConsultaRegistros();
        }
    }, [reload]);

    useEffect(() => {
        if (prevDataPM && (paginationModel.page !== prevDataPM.page || paginationModel.pageSize !== prevDataPM.pageSize)) {
            realizarConsultaRegistros();
        }
    }, [paginationModel]);

    useEffect(() => {
        if (registrosData) {
            setRowCount(registrosData.page.totalElements);
            setRegistros(registrosData.content || [])
        }
    }, [registrosData]);

    const realizarConsultaRegistros = (resetPM = false) => {
        setRegistros(null);
        if (resetPM) {
            setPaginationModel(GRID_DEFAULT_PAGINATION_MODEL);
        }
        registrosApi(consultarEstanciasAbiertas(normalizeFiltros(filtros), resetPM ? GRID_DEFAULT_PAGINATION_MODEL : paginationModel));
    }

    const handleRegistrarIncidencia = () => {
        const tags = selected.map(id => registros.find(r => r.id === id)).map(r => r.tag);
        //const estancias = selected.map(id => registros.find(r => r.id === id));
        navigate(`incidencia`, { state: { tags, registros: selected } });
    }

    const handleCierreEstanciaPensionado = () => {
        const tags = selected.map((id) => registros.find((r) => r.id === id)).map((r) => (r.tag));
        //const _registros = selected.map((id) => registros.find((r) => r.id === id));
        navigate(`cerrarEstanciaPension`, { state: { tags, registros: selected } });
    }

    const handleUpdateList = () => {
        setSelected([]);
        realizarConsultaRegistros();
    }

    const columns = useMemo(() => [
        {
            field: 'tag', headerName: 'Tag', minWidth: 150,
            valueGetter: value => formatTag(value)
        },
        {
            field: 'fechaEntrada', headerName: 'Fecha Entrada', minWidth: 120,
            valueGetter: value => formatDateInYear(value, 'MMM D', ' HH:mm', ', YYYY')
        },
        {
            field: 'tipoEstancia', headerName: 'Tipo', width: 110,
        },
        {
            field: 'tiempoEstancia', headerName: 'Tiempo de estancia', minWidth: 200,
            valueGetter: renderTiempoEstancia
        },
        {
            field: 'nombreCarril', headerName: 'Carril', minWidth: 200, flex: 1
        }
    ], []);

    const isSelectedOnly = (tipoEstancia) => {
        return registros && selected.length > 0 && selected.every((id) => registros.find((r) => r.id === id).tipoEstancia === tipoEstancia);
    }

    return (
        <>
            <Outlet />
            <Panel>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                    {/* <IconButton onClick={() => navigate('..')} color="secondary">
                        <ArrowBackIcon />
                    </IconButton> */}
                    <Typography variant="body1" color="secondary" sx={{ fontWeight: 450 }}>Estancias abiertas</Typography>
                </Box>
                <Box sx={{ mt: 1, display: 'flex', gap: 2 }}>
                    <Button variant="contained" color="primary" disabled={!isSelectedOnly('COMERCIAL')} onClick={handleRegistrarIncidencia}>Registrar incidencia</Button>
                    <Button variant="contained" color="primary" disabled={!isSelectedOnly('PENSION')} onClick={handleCierreEstanciaPensionado}>Cerrar estancia pensionado</Button>
                </Box>
            </Panel>
            <Box sx={{ mt: 2 }}>
                {loadingEstancias &&
                    <TableLoader columns={columns} rowsNum={5} />
                }
                {registros && registros.length === 0 &&
                    <EmptyStateLabel text="No existen registros con esos criterios" />
                }
                {registros && registros.length > 0 &&
                    <Paper elevation={0} sx={{ width: '100%', borderRadius: 6 }}>
                        <DataGrid
                            sx={{ borderRadius: 6 }}
                            autoHeight
                            checkboxSelection
                            disableRowSelectionOnClick
                            columns={columns}
                            rows={registros}
                            rowCount={rowCount}
                            loading={loadingEstancias}
                            pageSizeOptions={[10, 20, 50, 100]}
                            paginationModel={paginationModel}
                            paginationMode="server"
                            onPaginationModelChange={setPaginationModel}
                            onRowSelectionModelChange={(rowSelectionModel) => setSelected(rowSelectionModel)}
                        />
                    </Paper>
                }
            </Box>
            <Routes>
                <Route path="incidencia" element={<RegistrarIncidenciaDialog onShouldUpdate={handleUpdateList} />} />
                <Route path="cerrarEstanciaPension" element={<CerrarEstanciaPensionado onShouldUpdate={handleUpdateList} />} />
            </Routes>
        </>
    );
}